
import * as moment from "moment";

import * as actions from "../../shared/timeclock/actions";
import * as deviceactions from "../actions/device";
import { Action } from "redux";

export interface Screensaver {
    lastEvent: moment.Moment;
    active: boolean;
}

const TIMEOUT = 5 * 60;

export function screensaver(state: Screensaver, action: Action): Screensaver {

    if (state === undefined) {
        return { lastEvent: moment(), active: false };
    }

    switch (action.type) {
        case actions.SCREENSAVER_POLL:
            return { ...state, active: moment.duration(moment().diff(state.lastEvent)).asSeconds() > TIMEOUT };
        case deviceactions.DEVICE_STATUS:
        case actions.SESSION_REFRESH:
        case actions.API_OFFLINE:
            return state;
        default:
            return { ...state, lastEvent: moment(), active: false };
    }
}
